import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Widgets */
import Control from "./Control"
import Dealer from "./Dealer"
import Message from "./Message"
import Currency from "./Currency"
import Settings from "./Settings"

/* Translate */
import { t } from "../../translates/translate"

/* Icons */
import { CloseIcon, SlidersIcon, ChatIcon, DealerIcon, CurrencyIcon, SettingsIcon } from "../../components/Icons"


/* PANELS OF A TABLE — THE VERY SAME LIST SERVES A LIVE GAME AND AN ELECTRON GAME */
export const PANELS = {

    control: {
        text: () => t("game.parameters"),
        hint: () => t("panel.controlHint"),
        icon: (size) => <SlidersIcon size={size} />,
        tone: "blue",
    },

    message: {
        text: () => t("game.messages"),
        hint: () => t("panel.messageHint"),
        icon: (size) => <ChatIcon size={size} />,
        tone: "violet",
    },

    dealers: {
        text: () => t("game.dealers"),
        hint: () => t("panel.dealerHint"),
        icon: (size) => <DealerIcon size={size} />,
        tone: "amber",
    },

    currencies: {
        text: () => t("game.currencies"),
        hint: () => t("panel.currencyHint"),
        icon: (size) => <CurrencyIcon size={size} />,
        tone: "green",
    },

    settings: {
        text: () => t("game.settings"),
        hint: () => t("panel.settingsHint"),
        icon: (size) => <SettingsIcon size={size} />,
        tone: "gray",
    },

}


/* Widget TablePanel — one modal for every panel of a table, opened by the page through a ref */
class TablePanel extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            page: "",
        }
    }

    /* Open Action */
    open = (page) => {
        this.setState({ visible: true, page })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, page: "" })
    }

    /* Panel Of The Key — a page may pass its own panels next to the shared ones */
    getPanel = () => {

        /* Fields */
        const { extra } = this.props
        const { page } = this.state

        /* Check Extra */
        if (extra && Array.isArray(extra)) {

            const index = extra.findIndex((item) => item.key === page)

            if (index > -1) {
                return extra[index]
            }
        }

        /* Send Result */
        return PANELS[page] || null
    }

    /* Content Of The Open Panel */
    getContent = () => {

        /* Fields */
        const { uid, socket, blackjack, isRoulette } = this.props
        const { page } = this.state

        if (page === "control") {
            return <Control uid={uid} socket={socket} />
        }

        if (page === "message") {
            return <Message uid={uid} socket={socket} />
        }

        if (page === "dealers") {
            return <Dealer uid={uid} socket={socket} isRoulette={isRoulette} />
        }

        if (page === "currencies") {
            return <Currency uid={uid} blackjack={blackjack} />
        }

        if (page === "settings") {
            return <Settings uid={uid} />
        }

        /* Panels Of The Page Itself */
        const panel = this.getPanel()

        return panel && panel.content ? panel.content() : null
    }

    render = () => {

        /* Fields */
        const { visible, page } = this.state
        const panel = this.getPanel()
        const wide = panel && panel.wide

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className={`tbl--modal ${wide ? "wide" : ""}`}
                overlayClassName={`tbl--overlay ${wide ? "center" : ""}`}
                closeTimeoutMS={200}
            >

                <div className="tbl--modal-header">

                    <div className={`tbl--modal-icon ${panel && panel.tone ? panel.tone : ""}`}>
                        {panel && panel.icon(18)}
                    </div>

                    <div className="tbl--modal-head-text">
                        <h2>{panel ? panel.text() : ""}</h2>
                        {panel && panel.hint && <p>{panel.hint()}</p>}
                    </div>

                    <div onClick={() => this.close()} className="tbl--modal-close">
                        <CloseIcon size={16} />
                    </div>

                </div>

                {/* The panel is mounted only while the modal is open, so every opening reads it again */}
                <div className="tbl--modal-body" key={`${page}`}>
                    {visible && this.getContent()}
                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(TablePanel)
